import React, { Component } from "react";

import CmsHistoryAction from "./CmsHistoryAction";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import Preloader from "../../../shared/items/static/preloader";
import Scrollbars from "react-custom-scrollbars-2";

import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import { withServiceHistory } from "../../../shared/containers/contaynerServiceHistory";
import { states } from "../../../reducers/queriesStates";

import styles from "./cmsHistory.module.scss";
import CmsHisoryPaginationControl from "./CmsHisoryPaginationControl";

class CmsHistory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      actions: [],
    };
  }

  componentDidMount() {
    const { serviceHistoryActionsDataState, onGetServiceHistoryActions } = this.props;

    if (serviceHistoryActionsDataState !== states.READY) {
      onGetServiceHistoryActions();
    }
  }

  componentDidUpdate(prevProps) {
    const { serviceHistoryDataState, serviceHistory } = this.props;

    if (serviceHistoryDataState === states.READY && prevProps.serviceHistoryDataState === states.REQUEST) {
      this.setState({ actions: serviceHistory.actions });
    }
  }

  onSelectFilter(e) {
    const { onChangeFilter = () => {} } = this.props;

    onChangeFilter(e.target.value);
  }

  render() {
    const {
      title,
      onClose,
      serviceHistoryDataState,
      serviceHistoryActions,
      onChangeStore = () => {},
      page = 1,
      serviceHistoryCount,
      serviceHistoryTotalCount,
    } = this.props;
    const { actions } = this.state;

    if (serviceHistoryActions.length === 0) {
      return null;
    }

    const totalCount = actions.length < serviceHistoryCount ? actions.length : serviceHistoryTotalCount;

    return (
      <div className={styles.cmsHistory}>
        <div className={styles.cmsHistoryContent}>
          <div className={styles.cmsHistoryTitleBlock}>
            <h1>{title}</h1>

            <div className={styles.cmsHistoryClose}>
              <TooltipWrapper title={"Закрыть"} position="top">
                <div onClick={onClose}>
                  <HighlightOffIcon />
                </div>
              </TooltipWrapper>
            </div>
          </div>
          <div>
            <Select
              /*               style={{ minWidth: "700px", height: "40px" }} */
              style={{ width: "340px", height: "24px", margin: "0px", fontSize: "12px" }}
              onChange={this.onSelectFilter.bind(this)}
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
            >
              <MenuItem value={null} className={styles.MuiButtonBase_resolve}>
                {"- - - "}
              </MenuItem>
              {serviceHistoryActions.map((x, index) => {
                return (
                  <MenuItem key={index} value={x.value} className={styles.MuiButtonBase_resolve}>
                    {x.title}
                  </MenuItem>
                );
              })}
            </Select>
          </div>
          {serviceHistoryDataState !== states.READY && serviceHistoryDataState !== states.FAILURE ? (
            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
              <Preloader />
            </div>
          ) : (
            <div className={styles.cmsHistoryActions}>
              <div style={{ margin: "10px 0px" }}>Количество действий: {totalCount}</div>
              <Scrollbars ref="scrollbar" style={{ height: "600px" }} autoHide={false}>
                {actions.map((action) => {
                  return <CmsHistoryAction key={action.id} action={action} />;
                })}
              </Scrollbars>
              <CmsHisoryPaginationControl onChangeStore={onChangeStore} page={page} totalCount={totalCount} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withServiceHistory(CmsHistory);
